let current = null;

const devices = [
	{ name: "mobile", min: 0, max: 568 },
	{ name: "tablet", min: 569, max: 767 },
	{ name: "desktop", min: 768, max: 1023 },
	{ name: "desktopLarge", min: 1024, max: Number.MAX_SAFE_INTEGER },
	{ name: "infinite", min: Number.MAX_SAFE_INTEGER, max: Number.MAX_SAFE_INTEGER },
];

class Resolution {
	constructor() {
		this.smallMobileResolutionSplit = 569;
		this.mobileResolutionSplit = 750;
		this.tabletResolutionSplit = 1007;

		this.mobile = devices[0];
		this.tablet = devices[1];
		this.desktop = devices[2];
		this.desktopLarge = devices[3];
		this.infinite = devices[4];

		this.devices = {
			mobile: this.mobile,
			tablet: this.tablet,
			desktop: this.desktop,
			desktopLarge: this.desktopLarge,
			infinite: this.infinite,
		};

		current = this.desktop;
	}

	currentMedia() {
		current = devices.filter((device) => this.between(window.innerWidth, device))[0];

		return current;
	}

	between(x, media) {
		return x >= media.min && x <= media.max;
	}

	isMobile() {
		return this.currentMedia().name === this.mobile.name;
	}

	isTablet() {
		return this.currentMedia().name === this.tablet.name;
	}

	isDesktop() {
		return this.currentMedia().name === this.desktop.name;
	}

	isDesktopLarge() {
		return this.currentMedia().name === this.desktopLarge.name;
	}

	isLargerThan(targetResolution) {
		if (isNaN(targetResolution)) {
			return window.innerWidth > targetResolution.max;
		}
		return window.innerWidth > targetResolution;
	}

	isLessThan(targetResolution) {
		if (isNaN(targetResolution)) {
			return window.innerWidth < targetResolution.min;
		}
		return window.innerWidth < targetResolution;
	}
}

export { Resolution };
